import { Injectable } from '@angular/core';
import { isSensitiveField } from './audit-logs.constants';
import { AuditFieldChange } from './audit-logs.interface';

@Injectable({ providedIn: 'root' })
export class AuditContextService {
  private formatFieldValue(value: unknown): string {
    if (value === undefined || value === null) {
      return '';
    }
    if (Array.isArray(value)) {
      return JSON.stringify(value);
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return String(value as string | number | boolean);
  }

  buildFieldChanges<T extends Record<string, unknown>>(
    original: Partial<T>,
    updated: Partial<T>,
    config: {
      sensitiveFields: string[];
      labelMap: Record<string, string>;
      excludeFields?: string[];
    }
  ): AuditFieldChange[] {
    const changes: AuditFieldChange[] = [];
    const { sensitiveFields = [], labelMap = {}, excludeFields = [] } = config;

    const allKeys = new Set([
      ...Object.keys(original),
      ...Object.keys(updated),
    ]);

    for (const key of allKeys) {
      if (excludeFields.includes(key)) continue;
      const oldValue = original[key];
      const newValue = updated[key];
      if (Object.keys(original).length > 0 && oldValue === newValue) {
        continue;
      }

      const isSensitive =
        isSensitiveField(key) || sensitiveFields.includes(key);

      changes.push({
        field: key,
        fieldLabel: labelMap[key] || key,
        oldValue: isSensitive ? null : this.formatFieldValue(oldValue),
        newValue: isSensitive ? null : this.formatFieldValue(newValue),
        isSensitive,
      });
    }

    return changes;
  }
}
